import React from "react";
import { connect } from 'react-redux';
import finxPayLogo from "../images/logo.png";
import IciciOnboarding  from "../component/icici-onboarding.component";
import IciciKyc  from "../component/icici-kyc.component";
import IciciKycSuccess  from "../component/icici-kyc-success.component";
import '../css/icici-style.css';
import '../css/master.css';
import '../css/bootstrap.min.css';
import { showIciciOnboardingSection, showIciciKycSection } from '../../redux/div-show-and-hide/div-show-and-hide.action';
import { store } from '../../redux/store';

   
class IciciKycProccess extends React.Component{
  
   constructor(props){
       super(props);
       this.state={
       }
   }

   handleBackClick = (event) => {
   
      if(this.props.showIciciKycSection == true){
         store.dispatch(showIciciOnboardingSection());
      }
      else if(this.props.showIciciKycSuccessSection == true){
         store.dispatch(showIciciKycSection());
      }
   }

render(){
      return(
         <>
                <header className="fixed-top">
	              <div className="container">
	            	<div className="row">
			         <div className="col-6">
			        	<div className="logo"><img src={finxPayLogo} alt="FinXpay" className="img-fluid"/></div>
			           </div>
			
			          <div className="col-6">
				        <div className="topbtn"><a onClick={this.handleBackClick} className="btn">Back</a></div>
			          </div>
	            	</div>
    	        </div>
               </header>
               {(this.props.showIciciOnboardingSection == true) &&
                  <IciciOnboarding />
               }
               {(this.props.showIciciKycSection == true) &&
                  <IciciKyc />
               }
               {(this.props.showIciciKycSuccessSection == true) &&
                  <IciciKycSuccess />
               }
               <div class="footer-txt">Copyright &copy; 2021 All rights reserved. <br />Powered by FinXpay Solutions Pvt. Ltd.</div>	               
            </>
         );
      }
}

const mapStateToProps = ({ divShowAndhide: {showIciciOnboardingSection, showIciciKycSection,showIciciKycSuccessSection}
    }) => ({
      showIciciOnboardingSection, showIciciKycSection,showIciciKycSuccessSection
   });

export default connect(mapStateToProps)(IciciKycProccess);